import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveSettings = [
  "settings",
  "users",
  "roles",
  "profiles",
  "groups",
  "sharing",
  "criteria-sharing",
  "brand-name",
  "assignment-rule",
  "objects-management",
  "fields-management",
  "create-template-record",
  "form-setting",
  "related-objects",
  "picklist-dependency",
  "kanban-view-setting",
  "knowledge-base-setting",
  "highlight-setting",
  "active-campaign",
  "duplicate-rules",
  "knowledge-base-enhancement-setting",
  "interaction",
  "object-standard",
  "quality-management-settings",
  "workflows",
  "sla-setting",
  "dynamic-button",
  "edit-dynamic-button",
  "approval-processes",
  "email-template",
  "email-incoming",
  "email-outgoing",
  "sms-template",
  "sms-outgoing",
  "consolidated-view-settings",
  "oauth-client-ids",
  "oauth-outlook",
  "cti-setting",
  "finesse-integration",
  "url-popup-setting",
  "voice-biometric",
  "voice-bot-setting",
  "expose-api-check",
  "expose-api-create",
  "expose-api-update",
  "expose-api-delete",
  "expose-api-view",
  "expose-api-upload",
  "external-app-integration",
  "ic-integration",
  "setting-datetime",
  "ldap",
  "system-log",
  "call-view-settings",
  "edit-profile",
  "profile-permission",
  "droplist-settings",
  "token-management",
  "apps-integration",
  "expose-api-interaction",
  "layout-setting",
  "agent-status",
];

const SettingIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveSettings.some((item) => item === pathname.split("/")[1]) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.425 8.45165C16.7659 8.45165 16.0875 7.27832 16.9125 5.83915C17.3892 5.00498 17.105 3.94165 16.2709 3.46498L14.685 2.55748C13.9609 2.12665 13.0259 2.38332 12.595 3.10748L12.4942 3.28165C11.6692 4.72082 10.3125 4.72082 9.47837 3.28165L9.37754 3.10748C8.96504 2.38332 8.03004 2.12665 7.30587 2.55748L5.72004 3.46498C4.88587 3.94165 4.60171 5.01415 5.07837 5.84832C5.91254 7.27832 5.23421 8.45165 3.57504 8.45165C2.62171 8.45165 1.83337 9.23081 1.83337 10.1933V11.8066C1.83337 12.76 2.61254 13.5483 3.57504 13.5483C5.23421 13.5483 5.91254 14.7216 5.07837 16.1608C4.60171 16.995 4.88587 18.0583 5.72004 18.535L7.30587 19.4425C8.03004 19.8733 8.96504 19.6166 9.39587 18.8925L9.49671 18.7183C10.3217 17.2791 11.6784 17.2791 12.5125 18.7183L12.6134 18.8925C13.0442 19.6166 13.9792 19.8733 14.7034 19.4425L16.2892 18.535C17.1234 18.0583 17.4075 16.9858 16.9309 16.1608C16.0967 14.7216 16.775 13.5483 18.4342 13.5483C19.3875 13.5483 20.1759 12.7691 20.1759 11.8066V10.1933C20.1667 9.23998 19.3875 8.45165 18.425 8.45165ZM11 13.9791C9.35921 13.9791 8.02087 12.6408 8.02087 11C8.02087 9.35915 9.35921 8.02082 11 8.02082C12.6409 8.02082 13.9792 9.35915 13.9792 11C13.9792 12.6408 12.6409 13.9791 11 13.9791Z"
            fill="#20A2A2"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 14.4375C9.1025 14.4375 7.5625 12.8975 7.5625 11C7.5625 9.1025 9.1025 7.5625 11 7.5625C12.8975 7.5625 14.4375 9.1025 14.4375 11C14.4375 12.8975 12.8975 14.4375 11 14.4375ZM11 8.9375C9.86333 8.9375 8.9375 9.86333 8.9375 11C8.9375 12.1367 9.86333 13.0625 11 13.0625C12.1367 13.0625 13.0625 12.1367 13.0625 11C13.0625 9.86333 12.1367 8.9375 11 8.9375Z"
            fill="#454F5B"
          />
          <path
            d="M13.9425 20.3408C13.75 20.3408 13.5575 20.3133 13.365 20.2674C12.7967 20.1116 12.32 19.7541 12.0175 19.2499L11.9075 19.0666C11.3667 18.1316 10.6242 18.1316 10.0834 19.0666L9.98254 19.2408C9.68004 19.7541 9.20337 20.1208 8.63504 20.2674C8.05754 20.4233 7.46171 20.3408 6.95754 20.0383L5.38087 19.1308C4.82171 18.8099 4.41837 18.2874 4.24421 17.6549C4.07921 17.0224 4.16171 16.3716 4.48254 15.8124C4.74837 15.3449 4.82171 14.9233 4.66587 14.6574C4.51004 14.3916 4.11587 14.2358 3.57504 14.2358C2.23671 14.2358 1.14587 13.1449 1.14587 11.8066V10.1933C1.14587 8.85494 2.23671 7.7641 3.57504 7.7641C4.11587 7.7641 4.51004 7.60827 4.66587 7.34244C4.82171 7.0766 4.75754 6.65494 4.48254 6.18744C4.16171 5.62827 4.07921 4.96827 4.24421 4.34494C4.40921 3.71244 4.81254 3.18994 5.38087 2.8691L6.96671 1.9616C8.00254 1.34744 9.36837 1.70494 9.99171 2.7591L10.1017 2.94244C10.6425 3.87744 11.385 3.87744 11.9259 2.94244L12.0267 2.76827C12.65 1.70494 14.0159 1.34744 15.0609 1.97077L16.6375 2.87827C17.1967 3.1991 17.6 3.7216 17.7742 4.3541C17.9392 4.9866 17.8567 5.63744 17.5359 6.1966C17.27 6.6641 17.1967 7.08577 17.3525 7.3516C17.5084 7.61744 17.9025 7.77327 18.4434 7.77327C19.7817 7.77327 20.8725 8.8641 20.8725 10.2024V11.8158C20.8725 13.1541 19.7817 14.2449 18.4434 14.2449C17.9025 14.2449 17.5084 14.4008 17.3525 14.6666C17.1967 14.9324 17.2609 15.3541 17.5359 15.8216C17.8567 16.3808 17.9484 17.0408 17.7742 17.6641C17.6092 18.2966 17.2059 18.8191 16.6375 19.1399L15.0517 20.0474C14.7034 20.2399 14.3275 20.3408 13.9425 20.3408ZM11 16.9491C11.8159 16.9491 12.5767 17.4624 13.0992 18.3699L13.2 18.5441C13.31 18.7366 13.4934 18.8741 13.7134 18.9291C13.9334 18.9841 14.1534 18.9566 14.3367 18.8466L15.9225 17.9299C16.1609 17.7924 16.3442 17.5633 16.4175 17.2883C16.4909 17.0133 16.4542 16.7291 16.3167 16.4908C15.7942 15.5924 15.73 14.6666 16.1334 13.9608C16.5367 13.2549 17.3709 12.8516 18.4159 12.8516C19.0025 12.8516 19.47 12.3841 19.47 11.7974V10.1841C19.47 9.6066 19.0025 9.12994 18.4159 9.12994C17.3709 9.12994 16.5367 8.7266 16.1334 8.02077C15.73 7.31494 15.7942 6.3891 16.3167 5.49077C16.4542 5.25244 16.4909 4.96827 16.4175 4.69327C16.3442 4.41827 16.17 4.19827 15.9317 4.0516L14.3459 3.1441C13.9517 2.90577 13.4292 3.04327 13.1909 3.4466L13.09 3.62077C12.5675 4.52827 11.8067 5.0416 10.9909 5.0416C10.175 5.0416 9.41421 4.52827 8.89171 3.62077L8.79087 3.43744C8.56171 3.05244 8.04837 2.91494 7.65421 3.1441L6.06837 4.06077C5.83004 4.19827 5.64671 4.42744 5.57337 4.70244C5.50004 4.97744 5.53671 5.2616 5.67421 5.49994C6.19671 6.39827 6.26087 7.3241 5.85754 8.02994C5.45421 8.73577 4.62004 9.1391 3.57504 9.1391C2.98837 9.1391 2.52087 9.6066 2.52087 10.1933V11.8066C2.52087 12.3841 2.98837 12.8608 3.57504 12.8608C4.62004 12.8608 5.45421 13.2641 5.85754 13.9699C6.26087 14.6758 6.19671 15.6016 5.67421 16.4999C5.53671 16.7383 5.50004 17.0224 5.57337 17.2974C5.64671 17.5724 5.82087 17.7924 6.05921 17.9391L7.64504 18.8466C7.83754 18.9658 8.06671 18.9933 8.27754 18.9383C8.49754 18.8833 8.68087 18.7366 8.80004 18.5441L8.90087 18.3699C9.42337 17.4716 10.1842 16.9491 11 16.9491Z"
            fill="#454F5B"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default SettingIcon;
